module.exports = __webpack_public_path__ + "img/cartoon_2.456099a1.jpg";